<template>
  <div @click="change" class="d-flex align-items-center cursor-pointer v2-text--small-2">
    <div>{{ props.title }}</div>
    <span class="flex-1"/>
    <chevron-icon class="icon-v2-secondary" :class="{ 'rotate-180': !expanded }"/>
  </div>
  <collapse>
    <div v-if="expanded">
      <slot/>
    </div>
  </collapse>
</template>

<script setup>
  import { ref } from 'vue';
  import Collapse from '@/components/transitions/collapse.vue';
  import ChevronIcon from '@/components/icons/chevron-icon.vue';

  const props = defineProps({
    title: {
      type: String,
      required: true,
    },
  });

  const emit = defineEmits(['expand']);

  const expanded = ref(false);

  function change() {
    expanded.value = !expanded.value;
    emit('expand', expanded.value);
  }
</script>
